import React from "react"

export default function CanvaButton({ className, title, onClick }) {
  return (
    <button className={`btn btn-light py-2 border ${className}`} style={{ borderRadius: "8px" }} onClick={onClick}>
      <img src="/dist/img/Canva_Icon_logo_256x256.png" alt="Canva Logo" width={"24px"} height={"24px"} />
      <span className="ml-2">{title}</span>
    </button>
  )
}
